import React, {Component} from 'react';
import './about.css';
import logo from '../../assets/img/Logo White.png';
import ilus from '../../assets/img/illus green.png';
import line from '../../assets/Group 35.png';

class About extends Component{
    render() {
        return (
            <div>
                <div className="jumbotron jumbotron-fluid" id="jumbo">
                    <div className="container container1">
                        <div className="containerimg">
                            <img src={logo} alt="logo_impulse" className="header_image"/>
                        </div>
                    </div>
                        <img src={line} alt="line" className="line"/>
                </div>
                <div className="container container1 container2">
                    <div className="isi">
                        <div className="about">
                            <h2>Tentang Impulse ITB</h2>
                            <p className="text-center">Impulse merupakan rangkaian acara yang diselenggarakan oleh Himpunan Mahasiswa Elektroteknik Institut Teknologi Bandung (HME ITB) bersama dengan IEEE ITB Student Branch. Impulse ditujukan sebagai wadah untuk meningkatkan pengetahuan, memantik ide dan inovasi serta berkarya pada bidang teknologi dan energi demi kemajuan bangsa Indonesia. Tema yang diangkat pada Impulse 2021 adalah "Smart City Application on The Indonesian New Capital City" dengan rangkaian acara yaitu workshop, kompetisi, dan grand seminar.</p>
                        </div>
                        <div className="row visi">
                            <div className="col-md-6 foto">
                                <img src={ilus} alt="visi" className="fotosize"/>
                            </div>
                            <div  className="col-md-6 visitext">
                                <h4 className="ml-3">Visi</h4>
                                <p className="ml-3">Impulse 2021 sebagai katalis masyarakat untuk berinovasi di bidang teknologi dan energi serta menjadi fondasi bagi HME ITB untuk terus berkarya dan berkembang.</p>
                            </div>
                        </div>
                        <div className=" ml-3 misi">
                            <h4>Misi</h4>
                            <ul>
                                <li>
                                <h5>Satisfaction in Innovation</h5> 
                                <p>Mengadakan acara yang mendorong inovasi di bidang teknologi dan energi, dan meninggalkan impresi baik untuk para peserta dan panitianya.</p>
                                </li>
                                <li>
                                <h5>Self-Growth</h5>
                                <p>Mengembangkan kemampuan anggota HME ITB untuk mencipta dan berkarya.</p>
                                </li>
                                <li>
                                <h5>Branding</h5>
                                <p>Mengembangkan branding yang kuat untuk menjadi fondasi Impulse berikutnya.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            
    
        )
    }
}

export default About